/* eslint-disable no-restricted-syntax */
/* eslint-disable func-name-matching */
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS } from 'utils/styles/fonts';

export const DefaultButton = ({
  children,
  width,
  height,
  bgColor,
  hoverBg,
  isCenter,
  mt,
  mb,
  ...props
}) => (
  <DefaultBtn
    width={width}
    height={height}
    bgColor={bgColor}
    hoverBg={hoverBg}
    isCenter={isCenter}
    mt={mt}
    mb={mb}
    {...props}
  >
    {children}
  </DefaultBtn>
);

DefaultButton.Circle = function Circle({
  children,
  width,
  height,
  bgColor,
  isCenter,
  hoverBg,
  mt,
  mb,
  ...props
}) {
  return (
    <BtnCircle
      width={width}
      height={height}
      bgColor={bgColor}
      isCenter={isCenter}
      hoverBg={hoverBg}
      mt={mt}
      mb={mb}
      {...props}
    >
      {children}
    </BtnCircle>
  );
};

export default DefaultButton;

const defaultPropTypes = {
  width: '155px',
  height: '48px',
  isCenter: false,
  mt: '0',
  mb: '0',
};

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
    .isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  bgColor: PropTypes.string,
  mt: PropTypes.string,
  mb: PropTypes.string,
  hoverBg: PropTypes.string,
  isCenter: PropTypes.bool,
};

DefaultButton.defaultProps = { ...defaultPropTypes };
DefaultButton.propTypes = { ...propTypes };
DefaultButton.Circle.defaultProps = {
  ...defaultPropTypes,
  width: '42',
  height: '42',
};
DefaultButton.Circle.propTypes = { ...propTypes };

const directionCenter = css`
  display: block;
  margin: 0 auto;
`;

const DefaultBtn = styled.button`
  ${FONTS.font24}
  color: ${COLORS.white};
  border-radius: 16px;
  background: ${({ bgColor }) => bgColor};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ isCenter }) => isCenter && directionCenter}
  margin-top: ${({ mt }) => mt}px;
  margin-bottom: ${({ mb }) => mb}px;
  &:hover {
    background: ${COLORS.mainColor_op7};
  }
  @media ${deviceMax.mobileS} {
    ${FONTS.font12}
  }
  @media ${deviceMax.mobileL} {
    ${FONTS.font14}
  }
  @media ${deviceMax.tablet} {
    ${FONTS.font16}
  }
  @media ${deviceMax.laptopL} {
    ${FONTS.font16}
  }
  @media ${deviceMax.desktop} {
    ${FONTS.font24}
  }

  :hover {
    background: transparent;
    border: 2px solid ${COLORS.mainColor};
    color: ${COLORS.mainColor};
  }
`;

const BtnCircle = styled(DefaultBtn)`
  ${FLEX_CONTAINER.FlexCenterRow}
  border-radius: 100%;
`;
